/*
 * @Description: 行业资讯骨架屏
 * @Author: liuzhezhe
 * @Date: 2023-08-04 11:27:47
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-08-04 13:38:41
 */
import React, { useState, useEffect } from 'react'
import styles from './index.scss'

const VideoSkeletons = (props) => {
  const [state] = useState([1, 2, 3, 4])

  useEffect(() => {

  }, [])

  return (
    <div className={styles['order-skeletons']}>
      {state.map(item => (
        <div className={styles['order-item']} key={item}>
          <div className={styles['skeletons']}></div>
          <div className={styles['content']}>
            <div className={styles['characters']}>
              <div className={styles['characters-t']}></div>
              <div className={styles['characters-t']}></div>
              <div className={styles['characters-t']}></div>
              <div className={styles['characters-b']}></div>
            </div>
            <div className={styles['time']}></div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default VideoSkeletons
